<template>
    <div>
        <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="errors.length > 0">
            {{errors}}
            <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
        </div>
    </div>
</template>

<script>
export default {
    name: "errors",
    data() {
        return {
            message:'Hello world'
        };
    },
    props: ["errors"]
}
</script>

<style scoped>

</style>